import { CasinoGameType, CasinoPromoConfig } from "./casino.types";

const sortQuestsByBadgeOrdering = (quests: any[]) => {
  return [...quests].sort((a: any, b: any) => {
    const orderingDiff =
      Number(a?.badge?.orderingScore ?? 0) - Number(b?.badge?.orderingScore ?? 0);
    if (orderingDiff !== 0) return orderingDiff;
    return Number(a?.stepId ?? 0) - Number(b?.stepId ?? 0);
  });
};

export const getResolvedCasinoData = ({
  isBadgeSource,
  casinoData,
  badgeCasinoData,
}: {
  isBadgeSource: boolean;
  casinoData?: CasinoPromoConfig;
  badgeCasinoData?: CasinoPromoConfig;
}) => {
  const data = isBadgeSource ? badgeCasinoData : casinoData;

  if (!data?.quest || !Array.isArray(data.quest)) {
    return data;
  }

  return {
    ...data,
    quest: sortQuestsByBadgeOrdering(data.quest),
  };
};

export const getShouldLoadOptInStatus = ({
  isBadgeSource,
  hasOptIn,
  isLoggedIn,
  promoRef,
}: {
  isBadgeSource: boolean;
  hasOptIn: boolean;
  isLoggedIn: boolean;
  promoRef?: string;
}) => {
  if (!hasOptIn || !isLoggedIn) {
    return false;
  }

  if (isBadgeSource) {
    return Boolean(promoRef);
  }

  return true;
};

export const getIsOptedIn = (optInStatus: any, isBadgeSource = false) => {
  if (isBadgeSource) {
    if (optInStatus === true) {
      return true;
    }

    if (!optInStatus || typeof optInStatus !== "object" || !!optInStatus.error) {
      return false;
    }

    return Boolean(
      optInStatus.isOptedIn ||
        optInStatus.optedIn ||
        optInStatus.optIn ||
        optInStatus.enrollementDate ||
        optInStatus.enrollmentDate ||
        optInStatus.id
    );
  }

  return (
    optInStatus === true || (!!optInStatus && typeof optInStatus === "object" && !optInStatus.error)
  );
};

export const getShouldLoadUserProgress = ({
  isLoggedIn,
  isBadgeSource,
  promoRef,
  hasOptIn,
  isOptedIn,
}: {
  isLoggedIn: boolean;
  isBadgeSource: boolean;
  promoRef?: string;
  hasOptIn: boolean;
  isOptedIn: boolean;
}) => {
  if (!isLoggedIn) {
    return false;
  }

  if (isBadgeSource && !promoRef) {
    return false;
  }

  return !hasOptIn || isOptedIn;
};

const userSpinsGameTypes = new Set<CasinoGameType>([
  CasinoGameType.Wheel,
  CasinoGameType.MultiWheel,
  CasinoGameType.MysteryBox,
  CasinoGameType.CardMatching,
  CasinoGameType.ScratchGame,
  CasinoGameType.CoinGathering,
  CasinoGameType.Penalty,
]);

export const getNeedsUserSpins = (gameType: CasinoGameType | null) => {
  return Boolean(gameType && userSpinsGameTypes.has(gameType));
};

export const getShouldLoadUserSpins = ({
  needsUserSpins,
  isLoggedIn,
  hasOptIn,
  isOptedIn,
}: {
  needsUserSpins: boolean;
  isLoggedIn: boolean;
  hasOptIn: boolean;
  isOptedIn: boolean;
}) => {
  return needsUserSpins && isLoggedIn && (!hasOptIn || isOptedIn);
};
